module.exports = __webpack_public_path__ + "img/icon-item-003.07e23c56.png";